import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '../../utils/store';
import { communityUserData } from '@/views/user/personal/typings';

export interface HomeCommunityState {
  posts: communityUserData[];
  game: any;
  is_end: boolean;
  is_state: boolean;
  next_page: number;
  // top_posts: any[];
}

const HOMERANKING_KEY = 'React-ts-ant-homeCommunity';

const localHomeCommunity = LocalStore.getValue<HomeCommunityState>(HOMERANKING_KEY) || {};

export const homeCommunity: HomeCommunityState = {
  posts: [],
  game: {},
  next_page: 0,
  is_end: false,
  is_state: true,
  // top_posts: [],
  ...localHomeCommunity
};

const HOME_RANKING_KEY = 'React-ts-ant-HOMECOMMUNITY';

export const updateHomeCommunity: (homeRankings: HomeCommunityState) => IAction<HomeCommunityState> = (
  homeRankings: HomeCommunityState
) => ({
  type: HOME_RANKING_KEY,
  payload: homeRankings
});

const homeCommunityReducer: Reducer<HomeCommunityState, IAction<any>> = (
  state = homeCommunity,
  action: IAction<any>
) => {
  const { type, payload } = action;

  switch (type) {
    case HOME_RANKING_KEY:
      LocalStore.setValue(HOMERANKING_KEY, payload as HomeCommunityState);
      return {
        ...payload
      };
    default:
      return {
        ...state
      };
  }
};

export default homeCommunityReducer;
